import { FC } from 'react';
import { MessageSquare } from 'lucide-react';

export const ChatEmptyState: FC = () => {
  return (
    <div className="h-[calc(100%-62px)] flex-1 flex flex-col items-center justify-center gap-4 bg-(--neutral-white-NW1000) rounded-2xl">
      <div className="w-16 h-16 rounded-full bg-(--secondary-B900)/10 flex items-center justify-center">
        <MessageSquare size={32} className="text-(--secondary-B900)" />
      </div>
      <div className="flex flex-col items-center gap-1">
        <h4 className="[font-size:var(--fs-h4)]! font-bold text-(--neutral-black-NB1000)! m-0!">
          Chat with your professors to ask queries
        </h4>
        <p className="[font-size:var(--fs-p4)]! text-(--neutral-black-NB700)! m-0!">
          Quick, clear and concise communication.
        </p>
      </div>
    </div>
  );
};
